import React from 'react'
import GlobalMemberActionsOverlay from '../sections/overlays/GlobalMemberActionsOverlay'
import TeamsActionsOverlay from '../sections/overlays/TeamsActionsOverlay'

//<---------------------- Global Project Members Page ---------------------->

export const globalProjectMembersTableColumns = [
  {key: 'name', label: 'NAME', isSorted: true, headerStyle: 'min-w-250px'},
  {
    key: 'role',
    label: 'SYSTEM ROLE',
    isSorted: false,
    headerStyle: 'min-w-150px',
  },
  {
    key: 'usage_count',
    label: 'PROJECTS',
    isSorted: true,
    headerStyle: 'min-w-120px',
    style: 'justify-content-center',
  },
  {
    key: 'created_at',
    label: 'REGISTRATION DATE',
    isSorted: true,
    headerStyle: 'min-w-200px',
  },
  {
    key: 'status',
    label: 'STATUS',
    isSorted: true,
    headerStyle: 'min-w-120px',
    style: 'justify-content-center',
  },
  {
    key: 'action',
    label: 'ACTION',
    render: (row: any) => React.createElement(GlobalMemberActionsOverlay, {memberData: row}),
    headerStyle: 'w-80px',
  },
]

export const memberProjectsListModalColumns = [
  {key: 'project_name', label: 'PROJECT'},
  {key: 'status', label: 'STATUS', style: 'justify-content-end'},
]

export const projectMemberListModalColumns = [
  {key: 'name', label: 'NAME'},
  {key: 'role', label: 'ROLE', style: 'justify-content-end'},
]

//<---------------------- Default Columns Page ---------------------->

export const defaultColumnsTableColumns = [
  {
    key: 'name',
    label: 'Name',
    headerClass: 'min-w-400px',
  },
  {
    key: 'description',
    label: 'Description',
    headerClass: 'min-w-400px',
  },
  {
    key: 'action',
    label: 'Action',
    headerClass: 'w-80px text-center',
  },
]

//<---------------------- Global Custom Fields Page ---------------------->

export const globalCustomFieldsTableColumns = [
  {
    key: 'name',
    label: 'NAME',
    headerClass: 'min-w-400px',
  },
  {
    key: 'field_type',
    label: 'FIELD TYPE',
    headerClass: 'w-150px',
  },
  {
    key: 'used_in_projects',
    label: 'USED IN PROJECTS',
    headerClass: 'w-200px',
  },
  {
    key: 'action',
    label: 'ACTION',
    headerClass: 'w-80px text-center',
  },
]

//<---------------------- Teams Page ---------------------->

export const ProjectTeamsTableColumns = [
  {key: 'name', label: 'NAME', isSorted: false, headerStyle: 'min-w-350px'},
  {key: 'member_counts', label: 'MEMBERS', isSorted: false, headerStyle: 'min-w-100px', style: 'justify-content-center'},
  {key: 'project_counts', label: 'PROJECTS', isSorted: false, headerStyle: 'min-w-100px', style: 'justify-content-center'},
  {key: 'created_at', label: 'CREATED DATE', isSorted: false, headerStyle: 'min-w-150px'},
  {
    key: 'status',
    label: 'STATUS',
    isSorted: true,
    headerStyle: 'min-w-100px',
    style: 'justify-content-center',
  },
  {
    key: 'action',
    label: 'ACTION',
    render: (row: any) => React.createElement(TeamsActionsOverlay, {TeamsData: row}),
    headerStyle: 'w-80px',
  },
]



export const customFieldTypesDropdownList = [
  {label: 'Text', value: 'text'},
  {label: 'Number', value: 'number'},
  {label: 'Date', value: 'date'},
  {label: 'Select', value: 'select'},
  {label: 'Multi Select', value: 'multi select'},
]

export const formatGlobalCustomFieldSubmitData = (data: any) => {
  const isGroup = ['multi select', 'select'].includes(data.datatype)
  const {group_values, ...remainingData} = data
  return {
    ...remainingData,
    ...(isGroup && {
      group_values: data.group_values.map((field: any) => field.value).join(','),
    }),
  }
}
